import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Container,
  Nav,
  Navbar as BootstrapNavbar,
  NavDropdown,
  Button,
} from "react-bootstrap";

import { useIsAuthenticated } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { NavbarAlarn } from "./navbar-alarm";
import { useGetAlarm } from "../../../api/alarm-api";
import { useAlarm } from "../../../context/alarm/alarm";
import * as ACTION from "../../../context/alarm/action";

import KiLogo from "../../../image/logo.svg";

export const Navbar = () => {
  const intl = useIntl();
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const getAlarm = useGetAlarm();

  const [open, setOpen] = useState(false);

  const {
    dispatch,
    state: { action },
  } = useAlarm();

  useEffect(() => {
    const loadAlarmInfo = async () => {
      try {
        await getAlarm((data) => {
          if (data instanceof Error) {
            throw data;
          } else {
            ACTION.updatedAlarm(
              dispatch,
              data.onSiteServiceWorksheetTask,
              data.notApproveonSiteServiceWorksheetTask,
              data.serviceWorksheetTask,
              data.emailTask,
            );
          }
        });
      } catch (ex) {}
    };

    if (action.reload) {
      loadAlarmInfo();
    }
  }, [dispatch, action, getAlarm]);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  const SignOutButton = () => {
    return (
      <>
        <NavbarAlarn className="d-none d-xl-flex me-2" />
        <NavDropdown className="d-none d-xl-block" title={accounts[0].name}>
          <NavDropdown.Item
            as={Button}
            onClick={() => {
              setOpen(false);
              handleLogout(false);
            }}
          >
            <FormattedMessage id="button.logout" />
          </NavDropdown.Item>
        </NavDropdown>
      </>
    );
  };

  const SignInButton = () => {
    return (
      <Button
        variant="link"
        onClick={() => {
          setOpen(false);
          handleLogin(false);
        }}
      >
        <FormattedMessage id="button.login" />
      </Button>
    );
  };

  const NavLinkRender = ({ to, title, allowedRoles }) => {
    if (
      allowedRoles.length !== 0 &&
      !accounts[0]?.idTokenClaims?.roles?.find((role) =>
        allowedRoles?.includes(role),
      )
    ) {
      return null;
    }

    return (
      <Nav.Link
        as={NavLink}
        to={to}
        data-bs-toggle="collapse"
        onClick={() => {
          setOpen(false);
        }}
      >
        {title}
      </Nav.Link>
    );
  };

  const NavbarRender = ({ isAuthenticated }) => {
    if (!isAuthenticated) {
      return null;
    }
    return (
      <>
        <div className="d-flex">
          <NavbarAlarn className="d-flex d-xl-none me-2" />
          <div className="d-block d-xl-none me-2">{accounts[0].name}</div>
          <BootstrapNavbar.Toggle
            onClick={() => {
              setOpen(!open);
            }}
          />
        </div>
        <BootstrapNavbar.Collapse>
          <Nav>
            <NavLinkRender
              to="/templates"
              title={intl.formatMessage({ id: "page.templates.title" })}
              allowedRoles={[`${process.env.REACT_APP_ADMIN_ROLE}`]}
            />
            <NavLinkRender
              to="/serviceworksheets"
              title={intl.formatMessage({ id: "page.serviceworksheets.title" })}
              allowedRoles={[`${process.env.REACT_APP_ADMIN_ROLE}`]}
            />
            <NavLinkRender
              to="/onsiteserviceworksheets"
              title={intl.formatMessage({
                id: "page.onsiteserviceworksheets.title",
              })}
              allowedRoles={[`${process.env.REACT_APP_ADMIN_ROLE}`]}
            />
            <NavLinkRender
              to="/servicehistory"
              title={intl.formatMessage({ id: "page.servicehistory.title" })}
              allowedRoles={[`${process.env.REACT_APP_ADMIN_ROLE}`]}
            />
            <NavLinkRender
              to="/emails"
              title={intl.formatMessage({ id: "page.emails.title" })}
              allowedRoles={[`${process.env.REACT_APP_ADMIN_ROLE}`]}
            />
            <NavLinkRender
              to="/apps"
              title={intl.formatMessage({ id: "page.apps.title" })}
              allowedRoles={[`${process.env.REACT_APP_SUPER_ADMIN_ROLE}`]}
            />
            <NavLinkRender
              to="/scheduledjobs"
              title={intl.formatMessage({ id: "page.scheduledjobs.title" })}
              allowedRoles={[`${process.env.REACT_APP_SUPER_ADMIN_ROLE}`]}
            />
            <Button
              className="d-block d-xl-none pt-2 pe-0 pb-2 ps-0 border-0 text-start"
              variant="link"
              onClick={handleLogout}
            >
              <FormattedMessage id="button.logout" />
            </Button>
          </Nav>
        </BootstrapNavbar.Collapse>
      </>
    );
  };

  return (
    <div className="navbar-component">
      <Container>
        <BootstrapNavbar
          className="justify-content-xl-between"
          expand="xl"
          expanded={open}
        >
          <BootstrapNavbar.Brand as={NavLink} to="/">
            <img
              src={KiLogo}
              alt={intl.formatMessage({ id: "app.title" })}
              width={170}
            />
          </BootstrapNavbar.Brand>
          <NavbarRender isAuthenticated={isAuthenticated} />
          {isAuthenticated ? <SignOutButton /> : <SignInButton />}
        </BootstrapNavbar>
      </Container>
    </div>
  );
};
